import { withNamespaces } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import {
    findMailboxLinkedCase,
    getMailboxCaseDetailLocation,
    getMailboxCaseDetailPath,
} from '../../../helpers';

const MessageIntentActions = ({
    t,
    intents = [],
    cases = [],
}) => {
    const location = useLocation();
    const linked = intents
        .map((item) => ({
            item,
            linkedCase: findMailboxLinkedCase(cases, item.code),
        }))
        .filter(({ linkedCase }) => getMailboxCaseDetailPath(linkedCase));

    if (!linked.length) {
        return null;
    }

    return (
        <div className="mailbox-intent-actions d-flex flex-wrap align-items-stretch">
            {linked.map(({ item, linkedCase }) => (
                <Link
                    key={item.code}
                    to={getMailboxCaseDetailLocation(linkedCase, location)}
                    className="btn btn-outline-primary mailbox-message-detail__intent me-2"
                    title={t(item.titleKey)}
                >
                    {t(item.buttonKey)}
                    <i className="mdi mdi-open-in-new ms-1" />
                </Link>
            ))}
        </div>
    );
};

export default withNamespaces()(MessageIntentActions);
